import { render } from "./Pemeriksaan.vue?vue&type=template&id=723f0f9a"
import script from "./Pemeriksaan.vue?vue&type=script&lang=js"
export * from "./Pemeriksaan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__